const IMAGE_FALLBACK = "/img/placeholder.jpg";

export function shuffleArray(array = []) {
  const shuffled = array.slice();

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));

    [shuffled[index], shuffled[randomIndex]] = [
      shuffled[randomIndex],
      shuffled[index],
    ];
  }

  return shuffled;
}

function normalizeText(value = "") {
  return String(value).trim().toLowerCase();
}

function getTechniqueImage(technique) {
  return (
    technique?.image1_url ||
    technique?.image_url ||
    technique?.image ||
    IMAGE_FALLBACK
  );
}

function getTechniqueName(technique) {
  return technique?.nom || technique?.name || "Technique inconnue";
}

function getTechniqueGrade(technique) {
  return technique?.ceinture || technique?.grade || "";
}

function getTechniqueFamily(technique) {
  return technique?.famille || technique?.family || "";
}

function getUniqueNames(techniques = []) {
  return Array.from(
    new Set(
      techniques
        .map((technique) => getTechniqueName(technique))
        .filter(Boolean),
    ),
  );
}

export function buildQuestions(
  techniques = [],
  {
    grade = "Toutes les ceintures",
    selectedGrades = [],
    count = 10,
    wrongCount = 3,
  } = {},
) {
  if (!Array.isArray(techniques) || techniques.length === 0) return [];

  const normalizedSelectedGrades = Array.isArray(selectedGrades)
    ? selectedGrades.map((item) => normalizeText(item)).filter(Boolean)
    : [];

  const hasMultipleGradeFilter = normalizedSelectedGrades.length > 0;

  const selectedGrade = normalizeText(grade);

  const pool = hasMultipleGradeFilter
    ? techniques.filter((technique) =>
        normalizedSelectedGrades.includes(
          normalizeText(getTechniqueGrade(technique)),
        ),
      )
    : selectedGrade === normalizeText("Toutes les ceintures")
      ? techniques
      : techniques.filter(
          (technique) =>
            normalizeText(getTechniqueGrade(technique)) === selectedGrade,
        );

  if (pool.length === 0) return [];

  const allNames = getUniqueNames(techniques);
  const seeds = shuffleArray(pool).slice(0, Math.min(count, pool.length));

  return seeds.map((technique, index) => {
    const correctAnswer = getTechniqueName(technique);
    const techniqueFamily = getTechniqueFamily(technique);

    const sameFamilyWrongAnswers = techniques
      .filter((item) => {
        const sameFamily =
          normalizeText(getTechniqueFamily(item)) ===
          normalizeText(techniqueFamily);

        const sameTechnique =
          item?.id && technique?.id ? item.id === technique.id : false;

        const sameName = getTechniqueName(item) === correctAnswer;

        return sameFamily && !sameTechnique && !sameName;
      })
      .map((item) => getTechniqueName(item));

    let wrongAnswers = shuffleArray(
      Array.from(new Set(sameFamilyWrongAnswers)),
    ).slice(0, wrongCount);

    if (wrongAnswers.length < wrongCount) {
      const otherAnswers = shuffleArray(
        allNames.filter(
          (name) => name !== correctAnswer && !wrongAnswers.includes(name),
        ),
      );

      wrongAnswers = wrongAnswers.concat(
        otherAnswers.slice(0, wrongCount - wrongAnswers.length),
      );
    }

    const options = shuffleArray([correctAnswer, ...wrongAnswers]).slice(
      0,
      wrongCount + 1,
    );

    return {
      id: technique?.id || `${correctAnswer}-${index}`,
      image: getTechniqueImage(technique),
      correctAnswer,
      options,
      famille: techniqueFamily,
      ceinture: getTechniqueGrade(technique),
      raw: technique,
    };
  });
}
